import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

const TotalOrders = ({ startDate, endDate }) => {
  const [totalOrders, setTotalOrders] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const apiUrl = process.env.REACT_APP_API_URL;
  useEffect(() => {
    if (!startDate || !endDate) return;
    const fetchTotalOrders = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetch(
          `${apiUrl}/admin/analytics/orders-overview?start_date=${startDate}&end_date=${endDate}`,
          {
            credentials: "include",
          }
        );
        const data = await response.json();
        setTotalOrders(data.total_orders); // Устанавливаем значение общего количества заказов
      } catch (error) {
        console.error("Ошибка загрузки общего количества заказов:", error);
        setError("Ошибка загрузки данных.");
      } finally {
        setLoading(false);
      }
    };

    fetchTotalOrders();
  }, [apiUrl, startDate, endDate]);

  if (loading) {
    return <span>…</span>;
  }

  if (error) {
    return <span>{error}</span>;
  }

  return <strong>{totalOrders}</strong>;
};

export default TotalOrders;
TotalOrders.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
};
